<template lang="pug">
    v-text-field(v-bind="textFieldProps" v-model="rut" :mask="mixRUTInputMask" prepend-icon='priority_high' :rules="[mixRUTRules.validRUT]" ref="rut")
</template>

<script>
import RUTUtils from '@/mixins/RUTUtils'
export default {
    name: 'rut-input',
    data: function(){
        return {
            rut: ''
        }
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        textFieldProps: {
            type: Object,
            default: function() {
                return {
                    label: 'RUT',
                }
            },
        },
    },
    watch: {
        rut: function(newVal) {
            this.mixRUTInputHandler(newVal)
            this.$emit('input', newVal)
            this.$emit('valid', this.$refs.rut.validate())
        },
    },
    mixins: [RUTUtils],
    created: function(){
        this.rut = this.value
    },
    // beforeUpdate: function(){
    //     this.rut = this.value
    // }
}
</script>
